import React, { createContext, useState, useEffect } from 'react';
import { themesData } from '../mock';

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('minimal');
  const [availableThemes] = useState(themesData);

  useEffect(() => {
    // Apply theme CSS variables to root
    const theme = availableThemes[currentTheme];
    if (theme) {
      const root = document.documentElement;
      root.style.setProperty('--theme-bg', theme.colors.background);
      root.style.setProperty('--theme-text', theme.colors.text);
      root.style.setProperty('--theme-accent', theme.colors.accent);
      root.style.setProperty('--theme-secondary', theme.colors.secondary);
    }
  }, [currentTheme, availableThemes]);

  const changeTheme = (themeName) => {
    if (availableThemes[themeName]) {
      setCurrentTheme(themeName);
      return true;
    }
    return false;
  };

  const getThemeList = () => {
    return Object.keys(availableThemes).map(key => ({
      name: key,
      ...availableThemes[key]
    }));
  };

  return (
    <ThemeContext.Provider value={{
      currentTheme,
      availableThemes,
      changeTheme,
      getThemeList,
      themeData: availableThemes[currentTheme]
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;